import { Pressable } from 'react-native'
import styled from 'styled-components/native'

import { Box } from 'widgets/Box'

export const Backdrop = styled(Pressable)`
  background-color: ${({ theme }) => theme.colors.black75};
  width: 100%;
  height: 100%;
  //cursor: default;
`

export const FilterOptionsContainerStyles = styled(Pressable)`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.borderRadius.sm}px;
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  width: 85%;
  max-width: ${({ theme }) => theme.maxWidth - 50}px;
  max-height: 95%;
  margin: auto auto;
  //cursor: default;
`

export const FullScreenContainerStyles = styled(Pressable)`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.borderRadius.md}px;
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: ${({ theme }) => theme.maxWidth - 50}px;
  max-height: 95%;
  margin: auto auto;
  //cursor: default;
`

export const CompactContainerStyles = styled(Pressable)`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.borderRadius.xs * 1.5}px;
  display: flex;
  justify-content: space-between;
  max-width: ${({ theme }) => theme.maxWidth - 50}px;
  max-height: 95vh;
  margin: auto auto;
  //cursor: default;
`

export const CloseContainer = styled(Box)`
  width: 100%;
`

export const ButtonsContainer = styled(Box)`
  width: 100%;
`
